/**
 * Samples one foot target from a normalized travel cycle.
 *
 * The stance excursion is `strideLength * stanceFraction`, so its local X derivative is exactly
 * the negative of root travel. Adding root X and target X therefore produces a locked world-space
 * foot during the whole planted interval.
 */
export function sampleGaitTarget(out, cycle, strideLength, stanceFraction, lift) {
  let phase = cycle - Math.floor(cycle);
  if (phase < 0) phase += 1;
  const excursion = strideLength * stanceFraction;
  if (phase < stanceFraction) {
    const t = phase / stanceFraction;
    out.x = excursion * (0.5 - t);
    out.y = 0;
  } else {
    const t = (phase - stanceFraction) / (1 - stanceFraction);
    const eased = smooth(t);
    out.x = mix(-excursion * 0.5, excursion * 0.5, eased);
    out.y = Math.sin(t * Math.PI) * lift;
  }
  return out;
}

function mix(a, b, t) {
  return a + (b - a) * t;
}

function smooth(t) {
  const clamped = Math.max(0, Math.min(1, t));
  return clamped * clamped * (3 - 2 * clamped);
}
